<template>
	<el-row :gutter="40">
  		<el-col :span="24"><p>На этой странице Вы можете добавить предмет в свою коллекцию.</p></el-col>
	  	<el-col :span="8">
			<el-form :model="form" :rules="rules" ref="form">
				<el-form-item label="Модификация" prop="mod">
				    <el-select @change="setItems" v-model="form.mod" placeholder="Выберите модификацию" style="width: 100%">
				    	<el-option v-for="item in filters" :value="item.value" :label="item.label"></el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item v-if="form.mod != ''" label="Наименование" prop="item">
					<el-image :src="itemIcon" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 5px;"><div slot="error" class="image-slot"></div></el-image>
				    <el-select @change="setItemIcon" v-model="form.item" :clearable="true" filterable remote :remote-method="remoteMethod" :loading="loading" placeholder="Напишите наименование" ref="item" style="width: 100%">
				    	<el-option v-for="item in options" :value="item.name" :label="item.displayName">
				    		<el-image style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 5px;" :src="item.image"></el-image>
				    		<span>{{item.displayName}}</span>
				    	</el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item>
				    <el-button type="primary" @click="submitForm('form')">Добавить</el-button>
				</el-form-item>
			</el-form>
	  	</el-col>
	</el-row>
</template>

<script>
import {db} from '../firebase.js';
import {addItem} from '../functions.js';
export default {
  	data() {
	    return {
	    	// modsList: modsList,
	    	filters: [],
	    	itemCollection: [],
	    	options: [],
	    	itemIcon: '',
	      	form: {
	      		mod: '',
	      		item: '',
		   	},
		   	rules: {
	          	mod: [{required: true, trigger: 'blur', message: 'Заполните это поле'},],
	          	item: [{required: true, trigger: 'blur', message: 'Заполните это поле'},],
	        },
	        loading: false,
	    };
  	},
	mounted() {
		var self = this;
		if (self.$route.params.item && self.$route.params.mod) {
			self.form.mod = self.$route.params.mod;
			self.form.item = self.$route.params.item;
			// self.setItems();
			self.setItemIcon();
			var item = self.$store.state.itemCollection[self.form.mod].find(el => {
        		return el.name == self.form.item;
        	});
        	// console.log(item);
        	self.options = [item];
		};
		self.filters = self.$store.state.filters;
		self.$store.subscribe((mutation, state) => {
	      	switch(mutation.type) {
	        	case 'updateFilters':
	        		self.filters = self.$store.state.filters;
	        	break;
	      	};
	    });
	},
  	methods: {
  		setItemIcon() {
  			var self = this;
  			var item = self.$store.state.itemCollection[self.form.mod].find(function(el){return el.name == self.form.item;});
  			if (item) {
  				this.itemIcon = item.image;
  			} else {
  				this.itemIcon = '';
  			};
  		},
  		setItems() {
  			var self = this;
  			self.options = [];
  			self.form.item = '';
  			self.itemIcon = '';
  		},
  		addItem: addItem,
      	submitForm(formName) {
      		var self = this;
        	self.$refs[formName].validate((valid) => {
	          	if (valid) {
	          		self.addItem({item: self.form.item, mod: self.form.mod}, true);
	          	} else {
	            	self.$notify({title: 'Ошибка', message: 'Ошибка валидации формы', type: 'error'});
	            	return false;
	          	}
        	});
      	},
      	remoteMethod(query) {
      		var self = this;
	        if (query !== '' && query.length > 2) {
	          	this.loading = true;
	          	setTimeout(() => {
	            	this.loading = false;
            		this.options = self.$store.state.itemCollection[self.form.mod].filter(item => {
	            		if (item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1 && item.mod == self.form.mod) {
		            		return item;
	            		};
	            	});
	          	}, 200);
	        } else {
	          this.options = [];
	        }
	    },
    },
};
</script>